{
  "pt_BR": "quartos-privados",
  "cs_CZ": "soukrome-pokoje",
  "da_DK": "private-vaerelser",
  "de_DE": "private-zimmer",
  "en_GB": "private-rooms",
  "es_ES": "habitaciones-privadas",
  "fi_FI": "yksityiset-huoneet",
  "fr_FR": "chambres-privees",
  "it_IT": "stanze-private",
  "ja_JP": "puraibe-to-rumu",
  "ko_KR": "sasil-bang",
  "nl_NL": "prive-kamers",
  "nb_NO": "private-rom",
  "pl_PL": "pokoje-prywatne",
  "pt_PT": "quartos-privados",
  "ru_RU": "chastnye-komnaty",
  "sv_SE": "privata-rum",
  "tr_TR": "ozel-odalar",
  "zh_CN": "si-ren-fang-jian"
}
